const allowedOriginFromJsHost = (jsHost) => {
  const jsHostFragments = jsHost.split('/');
  return `${jsHostFragments[0]}//${jsHostFragments[2]}`;
};

export default {
  allowedOriginFromJsHost,
};
